import { render, staticRenderFns } from "./SalesWidget.vue?vue&type=template&id=3d794913&scoped=true"
import script from "./SalesWidget.vue?vue&type=script&lang=js"
export * from "./SalesWidget.vue?vue&type=script&lang=js"
import style0 from "./SalesWidget.vue?vue&type=style&index=0&id=3d794913&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d794913",
  null
  
)

export default component.exports